import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import {
  Button,
  DropDownButton,
  DropDownButtonItem,
} from "@progress/kendo-react-buttons";
import { FiEdit, FiFileText } from "react-icons/fi";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  MdCancel,
  MdDelete,
  MdReceiptLong,
  // MdReceiptLong
} from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { checkAcessRights, formatIndianNumber } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  FINANCIAL_YEAR,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import {
  assignDriverToSales,
  cancelEInvoice,
  cancelEWay,
  deleteSales,
  generateEInvoice,
  generateEwayBill,
  getAllSales,
  getSalesByID,
} from "./services/sales.services";
import {
  clearFilterSales,
  clearSalesDetails,
  clearSalesID,
  setEWayBillDetail,
  setFilterSales,
  setSalesID,
} from "./salesSlice";
import { clearItemList } from "../Item/itemSlice";
import { filterClearIcon, printIcon } from "@progress/kendo-svg-icons";
import { Tooltip } from "@progress/kendo-react-tooltip";
import _debounce from "lodash/debounce";
import { TextBox } from "@progress/kendo-react-inputs";
import { FaEye } from "react-icons/fa";
import { GiSteeringWheel } from "react-icons/gi";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import {
  gstValidator,
  requiredValidator,
  skipValidator,
} from "../../components/formFields/CommonValidator";
import { IDriverList } from "../user/userModel";
import { getAllActiveDrivers } from "../user/services/user.services";
import { ErrorToast, SuccessToast } from "../../components/toast/Toasts";
import FormTextField from "../../components/formFields/FormTextField";
import moment from "moment";

interface FormChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const DummayChangeWatcher = ({ formRenderProps }: FormChangeWatcherProps) => {
  useEffect(() => {
    formRenderProps.onChange("dummayvalue", {
      value: null,
    });
  }, []);
  return null;
};
const Sales: React.FC = () => {
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  const handleCreate = () => {
    navigate("/sales/create");
  };

  return (
    <>
      <DeleteSalesDialog />
      <GenerateCancelEinvoiceDialog />
      <EWayBillInfoDialog />
      <AssignDriverDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Sales Invoice List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Add New"}
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <SalesGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const SalesGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isEditBtnRef = useRef<any>(false);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);

  const SalesList = useAppSelector((state) => state.sales.SalesList);
  const loading = useAppSelector((state) => state.sales.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterSales: any = useAppSelector((state) => state.sales.FilterSales);

  useEffect(() => {
    return () => {
      dispatch(clearItemList());
      dispatch(setCurrentPage(0));

      if (!isEditBtnRef.current) {
        dispatch(clearFilterSales());
      }
    };
  }, []);

  useEffect(() => {
    const payload = {
      ...FilterSales,
      financial_year: FINANCIAL_YEAR,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllSales(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEdit = (sale_guid: any) => {
      navigate("/sales/edit", {
        state: { sale_guid: sale_guid },
      });
    };

    const handleOpenDeleteDialog = (sale_guid: any) => {
      dispatch(openDialog("deleteSales"));
      dispatch(setSalesID(sale_guid));
    };

    const handleAssignDriver = async (sale_guid: any) => {
      const payload = {
        sale_guid: sale_guid,
      };
      const response = await dispatch(getSalesByID(payload));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(openDialog("assignDriverToSales"));
        dispatch(setSalesID(sale_guid));
      }
    };

    const handleSalesView = (sale_guid: any) => {
      window.open(`/salesprint/${sale_guid}`);
    };

    const handleSalesPrint = (sale_guid: any) => {
      window.open(`/salesprint/${sale_guid}?print=1`);
    };
    const handleGatePassPrint = (sale_guid: any) => {
      window.open(`/sales/gatepass/${sale_guid}`);
    };
    const handleEWAYPrint = (sale_guid: any) => {
      window.open(`/e-wayprint/${sale_guid}?print=1`);
    };
    const handleEnvelopePrint = (sale_guid: any) => {
      window.open(`/sales/envelope/${sale_guid}`);
    };

    const handleItemClick = (event: any) => {
      const clickedItem = event?.item?.text;

      if (clickedItem === "Sales Invoice") {
        handleSalesPrint(props.dataItem?.sale_guid);
      } else if (clickedItem === "Gate Pass") {
        handleGatePassPrint(props.dataItem?.sale_guid);
      } else if (clickedItem === "Envelope") {
        handleEnvelopePrint(props.dataItem?.sale_guid);
      } else if (clickedItem === "E-way Bill") {
        handleEWAYPrint(props.dataItem?.sale_guid);
      }
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            disabled={props.dataItem?.isenvoicegenerate}
            ref={isEditBtnRef}
            onClick={() => {
              isEditBtnRef.current = true;
              handleEdit(props.dataItem?.sale_guid);
            }}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            onClick={() => handleOpenDeleteDialog(props.dataItem?.sale_guid)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}

        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Assign Driver"
            onClick={() => handleAssignDriver(props.dataItem?.sale_guid)}
          >
            <GiSteeringWheel
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}

        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="View"
            onClick={() => handleSalesView(props.dataItem?.sale_guid)}
          >
            <FaEye className="absolute-position" style={{ fontSize: "24px" }} />
          </IconButton>
        )}
        {isPrintAccess && (
          <Tooltip anchorElement="target" position="top" parentTitle={true}>
            <DropDownButton
              className="sales-printing-opt-btn"
              svgIcon={printIcon}
              fillMode={"flat"}
              title="Print"
              themeColor={"primary"}
              onItemClick={handleItemClick}
              popupSettings={{
                anchorAlign: { horizontal: "right", vertical: "bottom" },
                popupAlign: { horizontal: "center", vertical: "top" },
              }}
            >
              <DropDownButtonItem text="Sales Invoice" />
              {props.dataItem?.isewaybillgenerate && (
                <DropDownButtonItem text="E-way Bill" />
              )}
              <DropDownButtonItem text="Gate Pass" />
            </DropDownButton>
          </Tooltip>
        )}
      </td>
    );
  };
  const MyBillGenerateCommandCell = (props: GridCellProps) => {
    const handleGenerateEInvoice = async (sale_guid: any) => {
      dispatch(openDialog("generateeinvoiceSales"));
      dispatch(setSalesID(sale_guid));
    };
    const handleCancelEInvoice = async (sale_guid: any) => {
      dispatch(openDialog("canceleinvoiceSales"));
      dispatch(setSalesID(sale_guid));
    };

    const handleGenerateEWayBill = async (data: any) => {
      dispatch(openDialog("generateEWayBillSales"));
      dispatch(setSalesID(data?.sale_guid));
      dispatch(
        setEWayBillDetail({
          vehicle_no: data?.vehicle_no,
          transport_name: data?.transport_name,
        })
      );
    };
    const handleCancelEWayBill = async (sale_guid: any) => {
      dispatch(openDialog("canceleEWayBillSales"));
      dispatch(setSalesID(sale_guid));
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        <div style={{ width: "100px" }}>
          {!props.dataItem?.isinvoicecancel && (
            <>
              {props.dataItem?.isenvoicegenerate ? (
                <span
                  style={{
                    backgroundColor: "#D1FADF",
                    color: "#065032",
                    padding: "3px 10px",
                    textTransform: "capitalize",
                    borderRadius: "10px",
                    fontWeight: "bold",
                  }}
                >
                  Generated
                </span>
              ) : (
                <span
                  style={{
                    backgroundColor: "rgb(254, 240, 199)",
                    color: "rgb(128, 55, 23)",
                    padding: "3px 10px",
                    textTransform: "capitalize",
                    borderRadius: "10px",
                    fontWeight: "bold",
                  }}
                >
                  {props.dataItem?.gst_no == "" ? "No GST!" : "Pending"}
                </span>
              )}
            </>
          )}
          {props.dataItem?.isinvoicecancel && (
            <>
              <span
                style={{
                  backgroundColor: "rgb(255, 200, 200)",
                  color: "rgb(255, 0, 20)",
                  padding: "3px 10px",
                  textTransform: "capitalize",
                  borderRadius: "10px",
                  fontWeight: "bold",
                }}
              >
                Cancelled
              </span>
            </>
          )}
        </div>

        {props.dataItem?.isenvoicegenerate ? (
          <>
            {isEditAccess && (
              <IconButton
                type="button"
                fillMode="flat"
                size="small"
                title="Cancel e-invoice"
                style={{
                  visibility: `${
                    props.dataItem?.isinvoicecancel || !props.dataItem?.gst_no
                      ? "hidden"
                      : "visible"
                  }`,
                }}
                disabled={props.dataItem?.isinvoicecancel}
                onClick={() => handleCancelEInvoice(props.dataItem?.sale_guid)}
              >
                <FiFileText
                  className="absolute-position"
                  style={{ fontSize: "24px" }}
                />
                <MdCancel
                  className="absolute-position"
                  style={{
                    fontSize: "15px",
                    top: "8px",
                    left: "9px",
                    background: "#fff",
                  }}
                />
              </IconButton>
            )}
          </>
        ) : (
          <>
            {isEditAccess && (
              <IconButton
                type="button"
                fillMode="flat"
                size="small"
                title="Generate e-invoice"
                disabled={props.dataItem?.isinvoicecancel}
                style={{
                  visibility: `${
                    props.dataItem?.isinvoicecancel || !props.dataItem?.gst_no
                      ? "hidden"
                      : "visible"
                  }`,
                }}
                onClick={() =>
                  handleGenerateEInvoice(props.dataItem?.sale_guid)
                }
              >
                <FiFileText
                  className="absolute-position"
                  style={{ fontSize: "24px", color: "green" }}
                />
              </IconButton>
            )}
          </>
        )}
        {!props.dataItem?.isewaybillgenerate ? (
          <>
            {isEditAccess && (
              <IconButton
                type="button"
                fillMode="flat"
                size="small"
                title="Generate E-Way Bill"
                style={{
                  visibility: `${
                    props.dataItem?.isinvoicecancel ||
                    !props.dataItem?.isenvoicegenerate ||
                    !props.dataItem?.gst_no ||
                    (props.dataItem?.state_id === 1 &&
                      !(props.dataItem?.total_amount >= 50000))
                      ? "hidden"
                      : "visible"
                  }`,
                }}
                onClick={() => handleGenerateEWayBill(props.dataItem)}
              >
                <MdReceiptLong
                  className="absolute-position"
                  style={{ fontSize: "24px", color: "green" }}
                />
              </IconButton>
            )}
            {/* {isEditAccess && (
              <IconButton
                type="button"
                fillMode="flat"
                size="small"
                title="Cancel e-Way Bill"
                style={{
                  visibility: "hidden",
                }}
                onClick={() => handleCancelEWayBill(props.dataItem?.sale_guid)}
              >
                <MdReceiptLong
                  className="absolute-position"
                  style={{ fontSize: "24px", color: "blue" }}
                />
                <FaPen
                  className="absolute-position"
                  style={{
                    fontSize: "15px",
                    top: "8px",
                    left: "9px",
                    color: "blue",
                    background: "#fff",
                  }}
                />
              </IconButton>
            )} */}
          </>
        ) : (
          <>
            {isEditAccess && (
              <IconButton
                type="button"
                fillMode="flat"
                size="small"
                title="Cancel e-Way Bill"
                style={{
                  visibility: `${
                    !props.dataItem?.gst_no ||
                    (props.dataItem?.state_id === 1 &&
                      !(props.dataItem?.total_amount >= 50000))
                      ? "hidden"
                      : "visible"
                  }`,
                }}
                onClick={() => handleCancelEWayBill(props.dataItem?.sale_guid)}
              >
                <MdReceiptLong
                  className="absolute-position"
                  style={{ fontSize: "24px" }}
                />
                <MdCancel
                  className="absolute-position"
                  style={{
                    fontSize: "15px",
                    top: "8px",
                    left: "9px",
                    background: "#fff",
                  }}
                />
              </IconButton>
            )}
            {/* {isEditAccess && (
              <IconButton
                type="button"
                fillMode="flat"
                size="small"
                title="Edit e-Way Bill"
                style={{
                  visibility: `${
                    !props.dataItem?.gst_no ||
                    !(props.dataItem?.total_amount >= 50000)
                      ? "hidden"
                      : "visible"
                  }`,
                }}
                onClick={() => handleCancelEWayBill(props.dataItem?.sale_guid)}
              >
                <MdReceiptLong
                  className="absolute-position"
                  style={{ fontSize: "24px", color: "#1c5554" }}
                />
                <FaPen
                  className="absolute-position"
                  style={{
                    fontSize: "15px",
                    top: "8px",
                    left: "9px",
                    color: "#1c5554",
                    background: "#fff",
                  }}
                />
              </IconButton>
            )} */}
          </>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 4 || props.index === 5 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  // if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        className="responsive-table"
        filterable={true}
        filter={filter}
        data={filter ? filterBy(SalesList, filter) : SalesList}
        onFilterChange={handleFilterChange}
        total={SalesList[0]?.itemcount || SalesList?.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          width={250}
          field="invoice_no_string"
          title="Invoice No"
          cell={(props: any) => (
            <td>
              <div
                className={
                  isEditAccess && !props.dataItem?.isenvoicegenerate
                    ? "hoverableName"
                    : "normalName"
                }
                onClick={() =>
                  isEditAccess &&
                  !props.dataItem?.isenvoicegenerate &&
                  navigate("/sales/edit", {
                    state: {
                      sale_guid: props.dataItem?.sale_guid,
                    },
                  })
                }
              >
                {props.dataItem?.invoice_no_string}
              </div>
            </td>
          )}
        />
        <Column field="invoice_date" title="Invoice Date" width={120} />
        <Column
          width={250}
          field="account_name"
          title="Account Name"
          filterCell={CommonFilterCell}
        />
        <Column
          width={150}
          field="total_amount"
          title="Total"
          cell={(props: any) => (
            <td className="text-end">
              {props.dataItem?.total_amount
                ? formatIndianNumber(props.dataItem?.total_amount)
                : null}
            </td>
          )}
        />

        {isEditAccess && (
          <Column
            field="id"
            title="Generate E-Invoice"
            cell={MyBillGenerateCommandCell}
            width={"200px"}
            locked={true}
            filterable={false}
          />
        )}
        {(isEditAccess || isDeleteAccess || isPrintAccess) && (
          <Column
            field="id"
            title="Actions"
            cell={MyEditCommandCell}
            width={"200px"}
            locked={true}
            filterable={false}
          />
        )}
      </KendoGrid>
    </>
  );
};

const EWayBillInfoDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const SalesID = useAppSelector((state) => state.sales.SalesID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterSales: any = useAppSelector((state) => state.sales.FilterSales);
  const EWayBillDetail: any = useAppSelector(
    (state) => state.sales.EWayBillDetail
  );
  const loading = useAppSelector((state) => state.sales.loading);

  const [initialValues, setInitialValues] = useState({
    TransMode: "1",
    TransId: "12AWGPV7107B1Z1",
    TransName: "",
    TransDocDt: "",
    TransDocNo: "",
    VehNo: "",
    VehType: "R",
  });
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      VehNo: EWayBillDetail?.vehicle_no
        ? EWayBillDetail?.vehicle_no.split(" ").join("")
        : "",
      TransName: EWayBillDetail?.transport_name,
    });
    setFormKey(formKey + 1);
  }, [EWayBillDetail]);

  const handleSubmit = async (values: any) => {
    if (SalesID) {
      try {
        const fordata = {
          sale_guid: SalesID,
          TransMode: values?.TransMode ? values?.TransMode : "",
          TransId: values?.TransId ? values?.TransId : "",
          TransName: values?.TransName ? values?.TransName : "",
          TransDocDt: values?.TransDocDt
            ? moment(values?.TransDocDt).format("DD/MM/YYYY")
            : null,
          TransDocNo: values?.TransDocNo ? values?.TransDocNo : null,
          VehNo: values?.VehNo ? values?.VehNo : null,
          VehType: values?.VehType ? values?.VehType : "R",
        };
        const response = await dispatch(generateEwayBill(fordata));
        if (response?.meta?.requestStatus === "fulfilled") {
          const payload = {
            ...FilterSales,
            financial_year: FINANCIAL_YEAR,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          };
          dispatch(clearSalesID());
          dispatch(getAllSales(payload));
          dispatch(closeDialog());
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
      }
    }
  };

  const handleCloseDialog = () => {
    dispatch(clearSalesID());
    dispatch(closeDialog());
  };
  const TRANSPORT_TYPE = [
    { label: "Road", value: "1" },
    { label: "Rail ", value: "2" },
    { label: "Air ", value: "3" },
    { label: "Ship ", value: "4" },
  ];
  const VEHICLE_TYPE = [
    { label: "Regular", value: "R" },
    { label: "ODC ", value: "O" },
  ];

  return (
    <>
      {dialogName === "generateEWayBillSales" && (
        <AppDialog className="e-way-bill-dialog">
          <>
            <Form
              key={formKey}
              onSubmit={handleSubmit}
              initialValues={initialValues}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement>
                  <GridLayout
                    // style={{ marginRight: 30 }}
                    gap={{ rows: 0, cols: 10 }}
                    // cols={[
                    //   { width: "25%" },
                    //   { width: "25%" },
                    //   { width: "25%" },
                    //   { width: "25%" },
                    // ]}
                  >
                    <GridLayoutItem>
                      <Typography.h4>E-way Bill Details</Typography.h4>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="TransMode"
                        label="Transport Mode"
                        // disabled={true}
                        placeholder="Transport Mode"
                        component={FormSelectionField}
                        options={TRANSPORT_TYPE?.map((tran: any) => {
                          return {
                            value: tran?.value,
                            label: tran?.label,
                          };
                        })}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="TransId"
                        label="Transporter GSTIN"
                        placeholder="Transporter GSTIN"
                        component={FormTextField}
                        validator={gstValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="TransName"
                        label="Transporter Name"
                        placeholder="Transporter Name"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="TransDocNo"
                        label="Transport Document No"
                        placeholder="i.e. TRAN/DOC/11"
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="VehNo"
                        label="Vehicle No"
                        placeholder="i.e. GJ01AA1111"
                        validator={
                          formRenderProps.valueGetter("TransMode") == 1
                            ? requiredValidator
                            : skipValidator
                        }
                        astrike={
                          formRenderProps.valueGetter("TransMode") == 1
                            ? true
                            : false
                        }
                        component={FormTextField}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="VehType"
                        label="Vehicle Type"
                        placeholder="select Vehicle"
                        // disabled={true}
                        component={FormSelectionField}
                        options={VEHICLE_TYPE?.map((tran: any) => {
                          return {
                            value: tran?.value,
                            label: tran?.label,
                          };
                        })}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>

                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "end",
                        marginTop: 15,
                      }}
                    >
                      <ButtonWithLoading
                        label={"Generate"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginLeft: 4 }}
                        onClick={handleCloseDialog}
                      >
                        Cancel
                      </Button>
                    </GridLayoutItem>
                  </GridLayout>
                  <DummayChangeWatcher formRenderProps={formRenderProps} />
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};
const GenerateCancelEinvoiceDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const SalesID = useAppSelector((state) => state.sales.SalesID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterSales: any = useAppSelector((state) => state.sales.FilterSales);
  const loading = useAppSelector((state) => state.sales.loading);

  const handleGenerateEinvoiceAction = async (ID: any) => {
    if (ID) {
      const res = await dispatch(generateEInvoice(ID));
      const payload = {
        ...FilterSales,
        financial_year: FINANCIAL_YEAR,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (res.meta.requestStatus === "fulfilled") {
        if (res?.payload?.Status === 200) {
          SuccessToast(res.payload?.Details);
          dispatch(getAllSales(payload));
          dispatch(closeDialog());
          dispatch(clearSalesID());
        } else {
          ErrorToast(res.payload?.Details);
          dispatch(getAllSales(payload));
          dispatch(closeDialog());
          dispatch(clearSalesID());
        }
      } else {
        dispatch(getAllSales(payload));
        ErrorToast(res.payload?.Details);
        dispatch(closeDialog());
        dispatch(clearSalesID());
      }
    }
  };

  const handleCancelEinvoiceAction = async (ID: any) => {
    if (ID) {
      const cancelpayload = {
        sale_guid: SalesID,
        CnlRem: "Wrong generate",
      };
      const res = await dispatch(cancelEInvoice(cancelpayload));
      const payload = {
        ...FilterSales,
        financial_year: FINANCIAL_YEAR,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(getAllSales(payload));
        dispatch(closeDialog());
        dispatch(clearSalesID());
      } else {
        dispatch(getAllSales(payload));
        dispatch(closeDialog());
        dispatch(clearSalesID());
      }
    }
  };
  const handleCancelEWayBillAction = async (ID: any) => {
    if (ID) {
      const cancelpayload = {
        sale_guid: SalesID,
        CanReasonCode: 2,
        CanRemark: "Puncher",
      };
      const res = await dispatch(cancelEWay(cancelpayload));
      const payload = {
        ...FilterSales,
        financial_year: FINANCIAL_YEAR,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(getAllSales(payload));
        dispatch(closeDialog());
        dispatch(clearSalesID());
      } else {
        dispatch(getAllSales(payload));
        dispatch(closeDialog());
        dispatch(clearSalesID());
      }
    }
  };

  return (
    <>
      {dialogName === "generateeinvoiceSales" && (
        <AppDialog>
          <>
            <Typography.h5>{"Generate E-Invoice"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to Generate E-Invoice ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <ButtonWithLoading
                  label="Generate"
                  type="button"
                  disabled={loading}
                  loading={loading}
                  onClick={() => handleGenerateEinvoiceAction(SalesID)}
                />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {dialogName === "canceleinvoiceSales" && (
        <AppDialog>
          <>
            <Typography.h5>{"Cancel E-Invoice"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to Cancel E-Invoice ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <ButtonWithLoading
                  label="Yes"
                  type="button"
                  disabled={loading}
                  loading={loading}
                  onClick={() => handleCancelEinvoiceAction(SalesID)}
                />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {dialogName === "canceleEWayBillSales" && (
        <AppDialog>
          <>
            <Typography.h5>{"Cancel E-Way Bill"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to Cancel E-Way Bill ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <ButtonWithLoading
                  label="Yes"
                  type="button"
                  disabled={loading}
                  loading={loading}
                  onClick={() => handleCancelEWayBillAction(SalesID)}
                />
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const DeleteSalesDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const SalesID = useAppSelector((state) => state.sales.SalesID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterSales: any = useAppSelector((state) => state.sales.FilterSales);

  const handleDeleteAction = async (ID: any) => {
    if (ID) {
      const response = await dispatch(deleteSales(ID));
      dispatch(setCurrentPage(0));
      const payload = {
        ...FilterSales,
        financial_year: FINANCIAL_YEAR,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllSales(payload));
        dispatch(closeDialog());
        dispatch(clearSalesID());
      } else {
        dispatch(getAllSales(payload));
        dispatch(closeDialog());
        dispatch(clearSalesID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteSales" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Sales "}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Sales ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(SalesID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const AssignDriverDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const SalesID = useAppSelector((state) => state.sales.SalesID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const SalesDetail = useAppSelector((state) => state.sales.SalesDetail);
  const loading = useAppSelector((state) => state.sales.loading);
  const DriverList = useAppSelector((state) => state.user.DriverList);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterSales: any = useAppSelector((state) => state.sales.FilterSales);

  useEffect(() => {
    dispatch(getAllActiveDrivers());

    return () => {
      dispatch(clearSalesDetails());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    const updatePayload = {
      sale_guid: SalesID,
      driver_id: values?.driver_id ? +values?.driver_id : null,
    };
    const response = await dispatch(assignDriverToSales(updatePayload));
    dispatch(setCurrentPage(0));
    const payload = {
      ...FilterSales,
      financial_year: FINANCIAL_YEAR,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    if (response.meta.requestStatus === "fulfilled") {
      dispatch(getAllSales(payload));
      dispatch(closeDialog());
      dispatch(clearSalesID());
      dispatch(clearSalesDetails());
    } else {
      dispatch(getAllSales(payload));
      dispatch(closeDialog());
      dispatch(clearSalesID());
      dispatch(clearSalesDetails());
    }
  };

  return (
    <>
      {dialogName === "assignDriverToSales" && (
        <AppDialog className="assign-driver-sales">
          <>
            <Form
              onSubmit={handleSubmit}
              initialValues={SalesDetail}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement>
                  <GridLayout
                    // style={{ marginRight: 30 }}
                    gap={{ rows: 0, cols: 10 }}
                    cols={[{ width: "100%" }]}
                  >
                    <GridLayoutItem
                      style={{ borderBottom: "1px solid whitesmoke" }}
                    >
                      <Typography.h5>{"Assign Driver"}</Typography.h5>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="driver_id"
                        label="Driver Name"
                        placeholder="Select a driver..."
                        component={FormSelectionField}
                        validator={requiredValidator}
                        astrike={true}
                        options={DriverList?.map(
                          (accountGroup: IDriverList) => {
                            return {
                              value: accountGroup?.id,
                              label: `${accountGroup?.first_name} ${accountGroup?.last_name}`,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "end",
                        marginTop: 20,
                      }}
                    >
                      <div>
                        <ButtonWithLoading
                          label={SalesDetail?.driver_id ? "Update" : "Save"}
                          type="submit"
                          disabled={!formRenderProps.allowSubmit || loading}
                          loading={loading}
                        />
                        <Button
                          type="button"
                          fillMode={"outline"}
                          themeColor={"primary"}
                          style={{ marginLeft: 4 }}
                          onClick={() => dispatch(closeDialog())}
                        >
                          Cancel
                        </Button>
                      </div>
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const CommonFilterCell = (props: any) => {
  const dispatch = useAppDispatch();
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterSales: any = useAppSelector((state) => state.sales.FilterSales);
  const isFilterRef = useRef(true);
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputField, setInputField] = useState(props.field || "");

  const onChange = (event: any) => {
    setInputValue(event.target.value);
    setInputField(event.target.name);
  };

  const delayedApiCall = React.useCallback(
    _debounce((updatedFilters: any) => {
      dispatch(setCurrentPage(0));
      const payload = {
        ...updatedFilters,
        financial_year: FINANCIAL_YEAR,
        limit: +pageLimit,
        skip: 0 * +pageLimit,
      };

      dispatch(getAllSales(payload));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (!isFilterRef.current) {
      const updatedFilters = { ...FilterSales, [inputField]: inputValue };
      dispatch(setFilterSales(updatedFilters));
      delayedApiCall(updatedFilters);
    } else {
      isFilterRef.current = false;
    }
    return () => {
      delayedApiCall.cancel();
    };
  }, [inputValue, delayedApiCall]);

  const onClearButtonClick = (event: any) => {
    event.preventDefault();
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: event,
    });

    const updatedFilters = { ...FilterSales, [props.field]: "" };
    dispatch(setFilterSales(updatedFilters));

    const payload = {
      ...updatedFilters,
      financial_year: FINANCIAL_YEAR,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };

    dispatch(getAllSales(payload));
  };

  return (
    <div className="d-flex">
      <TextBox
        value={FilterSales[props.field] || ""}
        name={props.field || ""}
        onChange={onChange}
      />
      <Button
        svgIcon={filterClearIcon}
        title="Clear"
        disabled={!FilterSales[props.field]}
        onClick={onClearButtonClick}
        type="button"
        style={{
          marginLeft: "8px",
        }}
      ></Button>
    </div>
  );
};

export default Sales;
